// removed by extract-text-webpack-plugin
module.exports = {"classDetail":"classDetail","fetching":"fetching","class-detail-esc":"class-detail-esc","class-detail-name":"class-detail-name","class-detail-header":"class-detail-header","lesson-teacher-list":"lesson-teacher-list","student-amount-list":"student-amount-list","icon-users":"icon-users"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/ClassDetail/ClassDetail.scss
// module id = 7HkZ
// module chunks = 0